"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const __1 = require("../../..");
const MoneyV2 = react_1.default.memo(({ moneyV2, shorten = false }) => {
    if (!moneyV2) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, __1.moneyV2ToString)(moneyV2, shorten) });
});
exports.default = MoneyV2;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9uZXlWMi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NoYXJlZC9zdG9yZWZyb250L01vbmV5VjIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtEQUEwQjtBQUMxQixnQ0FBMkM7QUFRM0MsTUFBTSxPQUFPLEdBQUcsZUFBSyxDQUFDLElBQUksQ0FBQyxDQUFDLEVBQUUsT0FBTyxFQUFFLE9BQU8sR0FBRyxLQUFLLEVBQWUsRUFBRSxFQUFFO0lBQ3ZFLElBQUksQ0FBQyxPQUFPLEVBQUU7UUFDWixPQUFPLElBQUksQ0FBQztLQUNiO0lBQ0QsT0FBTywyREFBRyxJQUFBLG1CQUFlLEVBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxHQUFJLENBQUM7QUFDbEQsQ0FBQyxDQUFDLENBQUM7QUFFSCxrQkFBZSxPQUFPLENBQUMifQ==